import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Menu, Footer, Intro, Status } from '../../components'

import './style.scss'

export default class Layout extends Component {
  render() {
    const {
      state,
      title,
      slug,
      category,
      description,
      children,
      site,
      inProgress,
      subtitle,
      deprecated,
      designOnly,
    } = this.props

    return (
      <div className={'layout ' + (state && ' layout--' + state) + ' ' + site}>
        <Menu state={state} site={site} slug={slug} />
        <div className="layout__body">
          <div className="layout__content">
            <div class="layout__header">
              <Status
                deprecated={deprecated}
                designOnly={designOnly}
                inProgress={inProgress}
              />
              <div className="category-title">
                {!subtitle ? category : subtitle}
              </div>
              <h1 className="page-title">{title}</h1>
              {description && (
                <Intro>
                  <p>{description}</p>
                </Intro>
              )}
            </div>
              {children}
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  subtitle: 'Overview',
  site: 'mt',
}
